import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_ADD_LINKS,

  ACTION_DELETE_SITE_FOOTER_LINK__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK__FAIL,

  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL,

  ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_LINKS:
      return action.payload.siteFooterLinks;

    default:
      return state;
  }
};

const translationsById = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_LINKS:
      return action.payload.siteFooterLinkTranslations;

    default:
      return state;
  }
};

const isLinkTranslationBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST:
      return { ...state, [action.payload.translationId]: true };

    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS:
    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL:
      return _omit(state, action.payload.translationId);

    default:
      return state;
  }
};

const isLinkBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK__REQUEST:
      return { ...state, [action.payload.linkId]: true };

    case ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS:
    case ACTION_DELETE_SITE_FOOTER_LINK__FAIL:
      return _omit(state, action.payload.linkId);

    default:
      return state;
  }
};

const isSiteLinkMaxNumberReached = (state = false, action) => {
  switch (action.type) {
    case ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED:
      return action.payload.siteLinkMaxNumberReached;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  translationsById,
  isLinkTranslationBeingDeleted,
  isLinkBeingDeleted,
  isSiteLinkMaxNumberReached,
});
